module.exports = __webpack_public_path__ + "img/InfoGrey.53285a3d.svg";